import { render } from "./FUploadImage.vue?vue&type=template&id=2f2d71d9&scoped=true"
import script from "./FUploadImage.vue?vue&type=script&lang=js"
export * from "./FUploadImage.vue?vue&type=script&lang=js"

import "./FUploadImage.vue?vue&type=style&index=0&id=2f2d71d9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f2d71d9"]])

export default __exports__